
import $ from "jquery";
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, Grid, Dropdown, TextArea, Form, Input } from 'semantic-ui-react';

import Loading from '../loading';
import Server from '../../functions/server';

class ExpenseDetailss extends React.Component {

  state = {
    expenseDetails: [], maxWidth: 'sm', fullWidth: true, openAddExpence: true, 
    toWhom: '', employeeDetails: [], expenseMaster: [], customer: [], remarks: ''
  }

  componentDidMount() {
      this.getExpense();
      this.getCustomer();
      this.getEmployee();
  }

  getCustomer() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST',
      url: Server() + 'expensemaster/getcustomer.php',
      success: function(data) {
        let customer = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            customer.push({ key: c.name, text: c.name, value: c.id })
          })
          context.setState({ customer, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again1!!!')
      }
    });
  }

  getEmployee() {
    let context = this;
    $.ajax({
    type: 'POST',
    url: Server() + 'EmployeeDetails/get.php',
    success: function(data) {
        context.setState({ load: false, });
        let employeeDetails = [];
        try {
        data = JSON.parse(data);
        data.map((c) => {
            employeeDetails.push({ text: c.name, key: c.name, value: c.id })
        })
        context.setState({ employeeDetails })
        } catch (e) {
        alert('Error!!!');
        }
    },
    error: function(e) {
        alert('Try again1!!')
        context.setState({ load: false });
    }
    });
  }

  getExpense() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST',
      url: Server() + 'expensemaster/get.php',
      success: function(data) {
        let expenseMaster = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            expenseMaster.push({ key: c.name, text: c.name, value: c.name })
          })
          context.setState({ expenseMaster, load: false })
        } catch (e) {
          console.log(e);
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again2!!!')
      }
    });
  }

  statesChange = (f, { value }) => {
    this.setState({ toWhom: value });
  }

  statesChange1 = (f, { value }) => {
    this.setState({ selectedCustomer: value });
  }

  statesChange2 = (f, { value }) => {
    this.setState({ selectedEmployee: value });
  }
  

  selectExpense = (f, { value }) => {
    this.setState({ expenseMasterSelected: value });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value })
  }

  render() {
      let toWhom = [
        { key: 'Customer', text: 'Customer', value: 'Customer' },
        { key: 'Employee', text: 'Employee', value: 'Employee' },
        { key: 'Branch', text: 'Branch', value: 'Branch' },
      ];

      let ledger = [
        { key: 'Cash', text: 'Cash', value: 'Cash' },
        { key: 'Cash/ChinnaSalem', text: 'Cash/ChinnaSalem', value: 'Cash/ChinnaSalem' },
        { key: 'Cash/ChinnaSalem', text: 'Cash/ChinnaSalem', value: 'Cash/ChinnaSalem' },
      ];

      let optionDropdown = (<div></div>);
      if (this.state.toWhom == 'Customer') {
        optionDropdown = (
            <div>
                getCustomer<br/>
                <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
                        fluid search selection onChange={this.statesChange1} fluid
                        options={this.state.customer} value={this.state.selectedCustomer} />
            </div>
        );
      }
      if (this.state.toWhom == 'Employee') {
        optionDropdown = (
            <div>
                Employee<br/>
                <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
                        fluid search selection onChange={this.statesChange2} fluid
                        options={this.state.employeeDetails} value={this.state.selectedEmployee} />
            </div>
        );
      }
    return (
      <div>
        <Button onClick={ () => { this.setState({ openAddExpence: true }) }}>Add</Button>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
          open={this.state.openAddExpence} onClose={ () => { this.setState({ openAddExpence: false }) }} 
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Add Expense</DialogTitle>
          <DialogContent>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={5}>
                    Date<br/>
                    <input type="date" id="date" value={this.state.from_date}
                        style={{height: 35 }} onChange={this.handleChange('from_date')} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={6}>
                    To Whom
                    <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
                        fluid search selection onChange={this.statesChange} fluid
                        options={toWhom} value={this.state.toWhom} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={5}>
                    Select Expense
                    <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
                        fluid search selection onChange={this.selectExpense} fluid
                        options={this.state.expenseMaster} value={this.state.expenseMasterSelected} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                    {optionDropdown}
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                    Payment Mode
                    <Dropdown placeholder='State' style={{ borderColor: '#5A9CBB' }}
                        fluid search selection onChange={this.statesChange} fluid
                        options={ledger} value={this.state.toWhom} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    Amount<br/>
                    <Input fluid placeholder="Amount" />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                    Remarks<br/>
                    <Form>
                        <TextArea value={this.state.remarks} onChange={this.handleChange('remarks')} fluid />
                    </Form>
                    
                </Grid.Column> 
              </Grid>
            

          </DialogContent>
          <DialogActions>

          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ExpenseDetailss;
